<template>
  <div>
    <el-dialog :visible="show" @close="$emit('close')">
      <div class="text-left text-lg mb-3">{{ isCopy?$t('复制商品'):$t('编辑商品') }}</div>
      <div class="flex justify-start items-center mb-5">
        <span class="title require">{{ $t('商品') }}：</span>
        <el-input v-model="name" class="rounded-none w-3/4"></el-input>
      </div>
      <div class="flex flex-col items-start mb-4">
        <span class="title require">{{ $t('商品图片') }}：</span>
        <ir-images v-model="images" imagesStyle="display:flex;justify-content:flex-start;margin:0 5rem"></ir-images>
      </div>

      <el-row class="pl-22 pr-10">
        <el-col :span="12" v-for="(value, key) in formData" :key="key">
          <el-row align="middle" type="flex" style="margin-bottom: 1rem">
            <el-col :span="5" class="truncate">
              <span :class="{ 'require': value.require }" class="title">{{ value.title }}</span>
            </el-col>
            <el-col :span="19">
              <el-input v-model="value.value" :placeholder="value.placeholder" v-if="value.type == 'input'"
                class="w-full"></el-input>
              <el-select v-model="value.value.id" :placeholder="$t('请选择')" v-else-if="value.type == 'select'" class="w-full">
                <el-option v-for="item in value.select" :key="item.id" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <div class="mb-3">
        <div class="text-left title require">{{ $t('商品详情') }}</div>
        <div class="pl-22 pr-10">
          <el-input type="textarea" :placeholder="$t('请输入商品的描述以提升转化')" maxlength="500" show-word-limit
            v-model="detail.text">
          </el-input>
        </div>
      </div>
      <ir-images v-model="detail.images"
        imagesStyle="display:flex;justify-content:flex-start;margin:0 5.4rem"></ir-images>
      <div class="flex justify-end">
        <el-button type="primary" @click="submit">{{ $t('保存并上架') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script >
import irImages from "@/components/base/ir-images.vue";
import { watchEffect, computed, ref, reactive, watch } from "@vue/composition-api";

export default {
  props: {
    show: Boolean,
    product: Object,
    pid: Number,
    isCopy: {
      type: Boolean,
      default: false
    },
  },
  components: { irImages },

  setup(props, ctx) {
    console.log("isCopy:",props.isCopy)
    const formData = reactive({
      price: {
        title: ctx.root.$t('价格'),
        value: '',
        type: 'input',
        require: true,
        inputType: 'digit',
        placeholder: ctx.root.$t('输入价格')
      },
      stock: {
        title: ctx.root.$t('库存'),
        value: '',
        type: 'input',
        require: true,
        select: [],
        inputType: 'number',
        placeholder: ctx.root.$t('输入库存')
      },
      budsizes: {
        title: ctx.root.$t('花苞大小'),
        value: [],
        type: 'select',
        require: true,
        select: []
      },
      norms: {
        title: ctx.root.$t('规格'),
        value: [],
        type: 'select',
        require: true,
        select: []
      },
      colors: {
        title: ctx.root.$t('颜色'),
        value: '',
        type: 'select',
        require: true,
        select: []
      },
      lengths: {
        title: ctx.root.$t('枝长'),
        value: '',
        type: 'select',
        require: true,
        select: []
      },
      maturities: {
        title: ctx.root.$t('成熟度'),
        value: '',
        type: 'select',
        require: true,
        select: []
      },
      levels: {
        title: ctx.root.$t('等级'),
        value: '',
        type: 'select',
        require: true,
        select: []
      },
      weight: {
        title: ctx.root.$t('重量'),
        value: '',
        type: 'input',
        require: true,
        placeholder: ctx.root.$t('输入重量kg')
      },
      intro: {
        title: ctx.root.$t('简介'),
        key: 'intro',
        value: '',
        type: 'input',
        inputType: 'text',
        placeholder: ctx.root.$t('输入简介')


      }

    })
    const attrsMap = {
      norms: ctx.root.$t('规格'),
      colors: ctx.root.$t('颜色'),
      lengths: ctx.root.$t('枝长'),
      budsizes: ctx.root.$t('花苞大小'),
      maturities: ctx.root.$t('成熟度'),
    }
    const detail = reactive({
      text: '',
      images: ''
    })
    const images = ref()
    const name = ref()
    const pproduct = ref()
    const pid = ref()
    const productDetail = ref("")
    const attrs = {
      'colors': 'color',
      'lengths': 'length',
      'norms': 'norm',
      'budsizes': 'budsize',
      'maturities': 'maturity',
      'levels': 'level'
    }
    const dealProduct = () => {
      let arr = ['colors', 'lengths', 'norms', 'budsizes', 'maturities', 'levels']
      
      arr.map(item => {
        if (pproduct.value[item]?.length) {
          
          // console.log("formData[item]:",formData[item])
          if(formData[item]){
            
            formData[item].select = pproduct.value[item]
          }
          
        } else {
          ctx.root.$delete(formData, item)
        }
      })
    }
    const getProductInfo = async (pid) => {
      let res = await ctx.root.$callapi('sup/getProductInfoById', {
        pid: props.pid
      })
      if (res.code == 0 && res.data?.items[0]) {
        console.log("getProductInfoById:",props.pid)
        let product = res.data.items[0]
        pproduct.value = product.pproduct
        dealProduct()
        name.value = product.name
        images.value = product.images
        console.log(33333)
        for (let i in attrs) {
          if (pproduct.value[i]?.length && product[attrs[i]]?.id) {
            if(!formData[i]){
              ctx.root.$set(formData, i, {
                title: attrsMap[i],
                value: [],
                type: 'select',
                require: true,
                select: []
              })
            }
            formData[i].value = product[attrs[i]]
            // console.log("attrs[i]:", attrs[i])
            // console.log("pproduct.value[i]:",pproduct.value[i])
            formData[i].select = pproduct.value[i]
            // console.log("pproduct-after:",formData)
          }
        }
        let arr = ['price', 'stock', 'weight', 'intro']
        arr.map(item => {
          formData[item].value = product[item]
        })
        productDetail.value = product.detail
        if (product.detail) {
          let text = product.detail.match(/([\s\S]*)!\[/)
          if (text) {
            detail.text = text[1]
          }
          let reg1 = /(https?:[^:<>"]*\/)([^:<>"]*)(\.((png!thumbnail)|(png)|(jpg)|(webp)|(jepg)))/
          let imgs = product.detail.match(reg1)
          if (imgs) {
            detail.images = imgs[0]
          }
          // detail.text = product.detail.match(/(\S*)!/)[1]
          // detail.images = product.detail.match(/\((\S*)\)/)[1]
        }
        console.log("getProductInfoById-formdata:",formData)
      }
    }
    watch(() => props.product, (v) => {
      if (v) {
        pproduct.value = JSON.parse(JSON.stringify(v))
        images.value = pproduct.value.images
        name.value = pproduct.value.name
        console.log(55555)
        dealProduct()
      }
    })
    watch(() => props.pid, (v) => {
      if (v) {
        getProductInfo()
      }
    })

    const submit = async () => {
      let param = {
        name: name.value,
        images: images.value,
        ppid: pproduct.value.ppid || pproduct.value.id,
        attrs: {}
      }
      console.log("props.pid:",props.pid)
      console.log("props.isCopy:",props.isCopy)
      if (props.pid && !props.isCopy) {
        param.pid = props.pid
      }
      if (!param.name) {
        return ctx.root.$toast(ctx.root.$t('请输入名称'))
      }
      if (!param.images) {
        return ctx.root.$toast(ctx.root.$t('请选择图片'))
      }
      for (let i in formData) {
        if (formData[i].require && !formData[i]?.value) {
          return ctx.root.$toast(ctx.root.$t('信息未填完整'))
        } else if (formData[i]?.value && formData[i].type == 'select') {
          // attrsthis.attrs[i]
          ctx.root.$set(param.attrs, attrs[i], formData[i].value.id)
        } else if (formData[i]?.value && formData[i].type == 'input') {
          ctx.root.$set(param, i, formData[i].value)
        }
      }
      try {
        let r = await ctx.root.$autoUploads(param, ['images'])
        console.log(r);
      } catch (e) {
        return ctx.root.$toast(ctx.root.$t('图片上传失败，请检查图片格式'))
      }
      let format = ""
      if (detail.images) {
        try {
          let r = await ctx.root.$getImageNames(detail.images)
          if (r.length) {
            format = `${detail.text}![${r[0].name}](${r[0].url})`
          } else {
            let reg1 = /(https?:[^:<>"]*\/)([^:<>"]*)(\.((png!thumbnail)|(png)|(jpg)|(webp)|(jepg)))/
						let img = productDetail.value.match(reg1)[0]
            // let img = productDetail.value.match(/!(\S*)/)[1]
            format = `${detail.text}!${img}`
          }
        } catch (e) {
          return ctx.root.$toast(ctx.root.$t('图片上传失败，请检查图片格式'))
        }
      } else if (detail.text) {
        format = detail.text
      }
      param.detail = format
      let res = await ctx.root.$callapi('sup/addOrUpdateProduct', param)
      if (res.code == 0 && res.data) {
        ctx.root.$toast(ctx.root.$t('操作成功'), 'success')
        ctx.emit('close')
        ctx.emit('reload')
      }
    }
    return { formData, name, images, detail, submit }
  }
}
</script>
<style scoped lang="scss">

</style>